// Copyright 2020 Prescryptive Health, Inc.

export const pause = (duration: number): Promise<void> =>
  new Promise((res) => setTimeout(res, duration));
